<script>
// import Vue from 'vue'
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from 'axios';
import { todoMethods, todoComputed } from "@/state/helpers";

// Vue.use(VueAxios, axios)

export default {
	page: {
		title: "Nuevo Registro",
		meta: [
			{
				name: "description",
				content: appConfig.description,
			},
		],
	},

	components: {
		Layout,
		PageHeader,
	},


	data() {
		return {
			filters: {
				total: { value: '', keys: ['total'] }
			},
			post:[],

// ************************************** Link
			title: "Sucursales",
			items: [
				{
					text: "Sucursales",
					href: '',
				},
				{
					text: "Nuevo Registro",
					active: true,
				},
			],
		

			search: '',
			info: null,
			showModal: false,
			isLoading: false,
			fullPage: true,
			canCancel: false,
			totalRows: 1,
			todoTotalRows: 1,
			currentPage: 1,
			todocurrentPage: 1,
			current: 1,
			perPage: 10,
			statData: 1,
			todoperPage: 10,
			pageOptions: [10, 25, 50, 100],
			todoOptions: [10, 50, 100, 150, 200],
			filter: null,
			todoFilter: null,
			filterOn: [],
			todofilterOn: [],
			sortBy: "age",
			sortDesc: false,
			useSlot: false,
			loader: "spinner",
			color: "#007bff",
			bgColor: "#FFFFFF",
			height: 128,
			width: 128,
			timeout: 3000, //ms
			fetchingStats: true,
			earningStatus: true,
			objeto:{
				estatus:true
			},
			id_negocio:''
		};
	},

	computed: {

		...todoComputed,
		/**
		 * Total no. of records
		 */
		rows() {
			return this.tableSucursales.length;
		},

		/**
		 * Todo list of records
		 */
		todoList() {
			return this.todos.length;
		},
	},
	
	mounted() {

		this.id_negocio = this.$route.params.id_negocio;
		this.items[0].href = `/sucursales/${this.id_negocio}`;

		// Set the initial number of items
		this.totalRows = this.response.data.data.length;

		this.todoTotalRows = this.todos.length;

		axios
		.get("collection.json") 
		.then(function(response){
			console.log(response.data.item[1])
		});

		setTimeout(() => {
			this.showModal = true;
		}, 1500);
	},

	methods: {
		
		atras(){
			const id_negocio = this.id_negocio;
			this.$router.push({
				name:'sucursales',
				params:{
					id_negocio
				}
			})
		},

		...todoMethods,

		getColor (estado) {
				if (estado == "Activo") return 'red'
				else return 'green'
			},

		handleInput(value, data) {
			this.editableDataItems[data.index][data.field.key] = value;
		},

		handleSubmit(){
			this.objeto.estatus = this.objeto.estatus === true ? 1 : '0';
			this.objeto.id_negocio = this.id_negocio;
			axios.post('https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/sucursales',this.objeto)
			.then((res) => {
				const {response=""} = res.data;
				if (response === true) {
					this.$swal(
						'Registro',
						'Nueva sucursal agregada correctamente',
						'success'
					);
					this.atras();
				} else {
					this.$swal(
						'Alerta',
						'No se pudo agregar',
						'warning'
					);
				}
			})
			.catch(err => {
				console.log(err);
				this.$swal(
					'Error',
					'Ocurrio un error',
					'error'
				);
			}); 
		}
		
	},


};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <v-row>
        <v-col md="12">
          <v-card>
            <div class="card-body">
							<v-row>
								<v-card-text>
									<h4 class="card-title mb-4">Información de la sucursal</h4>
								</v-card-text>
								<v-col md="4">
									<b><label class="form-check-label">Nombre</label> </b>
									<div class="mb-4">
										<b-form-input
											v-model="objeto.nombre"
											id="nombre"
											placeholder="Nombre"
										></b-form-input>
									</div>
								</v-col>
								<v-col md="4">
									<b><label class="form-check-label">Horario</label> </b>
									<div class="mb-4">
										<b-form-input
											v-model="objeto.horario"
											id="horario"
											placeholder="Horario"
										></b-form-input>
									</div>
								</v-col>
								<v-col md="4">
									<b><label class="form-check-label">Telefono</label> </b>
									<div class="mb-4">
										<b-form-input
											v-model="objeto.telefono"
											id="telefono"
											placeholder="Telefono"
										></b-form-input>
									</div>
								</v-col>
							</v-row>
							<v-row>
								<div class="col-sm-12 col-md-1">
									<b><label class="form-check-label">Estado </label> </b>
									<label class="switch" role="button">
										<input
											type="checkbox"
											:value="active"
											v-model="objeto.estatus"
											@change="update"
										/>
										<div
											class="circle"
											:class="{
												'circle-on': objeto.estatus,
												'circle-off': !objeto.estatus
											}"
										>
											<span>{{ label }}</span>
										</div>
									</label>
								</div>
							</v-row>
							<v-row>
								<v-col md="12"> 
									<h4 class="card-title">Domicilio sucursal</h4>
								</v-col>
								<v-col md="12"> 
									<b><label class="form-check-label">Ubicación</label> </b>
									<div class="mb-4">
										<b-form-input
											v-model="objeto.direccion"
											id="direccion"
											placeholder="Direccion"
										></b-form-input>
									</div>
								</v-col>  
							</v-row>
							<v-row> 
								<v-col md="6">
									<b><label class="form-check-label">Coordenadas</label> </b>
									<div class="mb-4">
										<b-form-input
											v-model="objeto.coordenadas"
											id="coordenadas"
											placeholder="Coordenadas"
											disabled
										></b-form-input>
									</div> 
								</v-col>
								<v-col md="6"> 
									<b><label class="form-check-label">Ciudad</label> </b>
									<div class="mb-4">
										<b-form-input
											v-model="objeto.ciudad"
											id="ciudad"
											placeholder="Ciudad"
											disabled
										></b-form-input>
									</div>
								</v-col>  
							</v-row>
              <v-row>
                <v-col md="12"> 
                  <v-btn
                    color="primary"
                    type="button"
                    v-on:click="handleSubmit();"
                  >
                    Guardar
                  </v-btn> 
                  <v-divider
                    class="mx-1"
                    inset
                    vertical
                  ></v-divider>
                  <v-btn 
                    color="error"
                    type="button"
                    @click="atras()"
                  >
                    Cancelar
                  </v-btn>
                </v-col>
              </v-row>
              <!-- </v-col> -->
            </div>
          </v-card>
        </v-col>
      </v-row>
  </Layout>
</template>

<style lang="scss">
	$default: black;
	$active: #2dc772;
	$inactive: #6c757d;
	$text: #9d9d9d;
	$text-hover: white;
	$size: 0.7rem;
	$w: 60px;
	$h: 25px;
	$circle: $h - 4;
	$toggle-dis: $w - $circle - 2;

	.switch {
			position: relative;
			display: inline-block;
			width: $w;
			height: $h;
			border-radius: 100px;

			.circle {
					display: flex;
					align-items: center;
					width: 100%;
					height: $h - 1;
					border-radius: 100px;
					background-color: $default;

					& > span {
							font-size: $size;
							color: $text;
							padding-left: $h + -6;
					}

					&::before {
							position: absolute;
							content: "";
							height: $circle;
							width: $circle;
							left: 1px;
							top: 1px;
							border-radius: 100px;
							background-color: white;
							-webkit-transition: 0.4s;
							transition: 0.4s;
					}

					&:hover {
							background-color: lighten($default, 20);

							& > span {
									color: $text-hover;
							}
					}
			}

			.circle-on {
					background-color: $active;

					& > span {
							color: white;
					}

					&:hover {
							background-color: white;
							border: 1px $active solid;

							&::before {
									background-color: $active;
							}

							& > span {
									color: $active;
							}
					}
			}

			.circle-off {
					background-color: $inactive;

					& > span {
							color: white;
					}

					&:hover {
							background-color: white;
							border: 1px $inactive solid;

							&::before {
									background-color: $inactive;
							}

							& > span {
									color: $inactive;
							}
					}
			}

			& input {
					display: none;

					&:checked + .circle:before {
							-webkit-transform: translateX($toggle-dis);
							-ms-transform: translateX($toggle-dis);
							transform: translateX($toggle-dis);
					}
			}
	}
</style>
